import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases, type Purchase } from '../data/purchases';
import { PRODUCT_NAME } from './constants';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<Purchase>(purchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[250px] animate-pop-in" aria-live="polite" data-id="element-180" data-mp="165hcgvwws971">
      <div className="relative overflow-hidden rounded-xl border-2 border-pf-coral bg-white p-2 pr-6 shadow-2xl ring-2 ring-pf-navy/80" data-id="element-181" data-mp="116cy7qv4nl9u">
        <div className="absolute inset-x-0 top-0 h-1 bg-pf-coral" data-id="element-182" data-mp="1awph7enan6dv" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1 top-1 rounded p-0.5 text-pf-ink transition-colors duration-150 ease-out hover:text-pf-navy" aria-label="Close notification" data-id="element-183" data-mp="1axhdkropt857">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-184" data-mp="x6ca1ei87vpl" />
        </button>
        <div className="flex items-center gap-2" data-id="element-185" data-mp="s5onp64y031p">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-pf-coral bg-pf-coral/20" data-id="element-186" data-mp="s4wqxrzlzz9u">
            <ShoppingBagIcon className="h-3.5 w-3.5 text-pf-navy" aria-hidden="true" data-id="element-187" data-mp="23ld9hu6gmw0x" />
          </span>
          <div className="min-w-0 leading-tight" data-id="element-188" data-mp="2aotjuc285thm">
            <p className="font-display text-[12px] font-extrabold text-pf-navy" data-id="element-189" data-mp="2ao1n2xww5ppr">{current.name}</p>
            <p className="text-[10px] font-semibold text-pf-ink" data-id="element-190" data-mp="2fm34zfikzizn">
              from {current.city}, {current.country}
            </p>
            <p className="mt-0.5 text-[10px] font-extrabold text-pf-coral" data-id="element-191" data-mp="2kkwhp5q1n5yr">
              just purchased {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </aside>;
}